<template>
  <el-dialog
    :visible.sync="visible"
    :title="text + '选择'"
    :width="width"
    :top="top"
    :fullscreen="fullscreen"
    :draggable="draggable"
    class="ls-select-common-dialog ls-select-org-dialog"
    :class="customClass"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :destroy-on-close="true"
    @close="close"
  >
    <div
      v-if="visible"
      class="ls-select-org-main"
      :style="{
        height: fullscreen ? '100%' : isNaN(height % 1) ? height : height + 'px'
      }"
    >
      <div class="main">
        <div class="left" :class="multiple ? '' : 'long'">
          <div class="header">
            <el-icon size="16">
              <User />
            </el-icon>
            <span>可选{{ text }}</span>
          </div>
          <div class="main">
            <div class="ls-select-search-box">
              <div class="search-item">
                <el-input v-model="filterText" :placeholder="`请输入${text}名称`" clearable />
              </div>
            </div>
            <div class="content-box">
              <el-scrollbar height="100%">
                <!--设置render-after-expand为false是因为要在js里面控制所有节点的显示/隐藏-->
                <el-tree
                  ref="lsOrgSelectTree"
                  :class="'ls-tree-' + type"
                  :node-key="nodeKey"
                  :indent="10"
                  :data="treeData"
                  :props="treeProps"
                  :check-strictly="true"
                  show-checkbox
                  :render-after-expand="false"
                  :disabled="selectable"
                  :filter-node-method="filterNode"
                  @check-change="handleNodeCheck"
                >
                  <template #default="{ node, data }">
                    <div :class="data.type === 1 ? 'ls-corp-node' : 'ls-depart-node'">
                      {{ node.label }}
                    </div>
                  </template>
                </el-tree>
              </el-scrollbar>
            </div>
          </div>
        </div>
        <div v-if="multiple" class="middle">
          <el-button size="small" type="primary" @click="addOrg">
            <el-icon size="16">
              <Right />
            </el-icon>
            <span>添加</span>
          </el-button>
          <el-button size="small" type="danger" @click="removeOrg">
            <el-icon size="16">
              <Back />
            </el-icon>
            <span>移除</span>
          </el-button>
        </div>
        <div class="right">
          <div class="header">
            <el-icon size="16">
              <CollectionTag />
            </el-icon>
            <span>已选{{ text }}</span>
          </div>
          <div class="ls-select-search-box">
            <div class="search-item">
              <el-input v-model="search.orgName" :placeholder="`请输入${text}名称`" clearable />
            </div>
          </div>
          <!--已选机构-->
          <div class="table-box">
            <el-table
              ref="checkedOrgTable"
              :data="tableData"
              size="default"
              style="width: 100%"
              height="100%"
              class="ls-table"
              border
              stripe
              show-overflow-tooltip
              empty-text="暂无数据"
              :header-cell-class-name="cellClass"
              :row-class-name="setRowClass"
            >
              <el-table-column
                v-if="multiple"
                :show-overflow-tooltip="false"
                type="selection"
                width="50"
                align="center"
                fixed
              />
              <el-table-column :label="text + '名称'" prop="name" width="200"></el-table-column>
              <el-table-column :label="text + '路径'" prop="normName" width="300"></el-table-column>
              <el-table-column label="操作" width="60" align="center" fixed="right">
                <template v-slot="{ row, $index }">
                  <span class="table-btn-delete" @click="delOrg(row, $index)">移除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="footer" :style="{ textAlign: align }">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="submit">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
// import { mockData } from "./mock.js";
import request from "../../../api/request";

export default {
  name: "LsSelectOrg",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "org",
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    draggable: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "1000px",
    },
    height: {
      type: String,
      default: "600px",
    },
    top: {
      type: String,
      default: "10vh",
    },
    customClass: {
      type: String,
      default: "",
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    align: {
      type: String,
      default: "right",
    },
    org: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      visible: this.show,
      text: "",
      search: {
        orgName: "",
      },
      tableData: [],
      filterText: "",
      treeData: [],
      nodeKey: "id",
      treeProps: {
        value: "id",
        label: "name",
        children: "children",
        disabled: (node) => {
          return this.selectable(node);
        },
      },
    };
  },
  watch: {
    show: {
      immediate: true,
      deep: true,
      async handler(newValue) {
        this.visible = newValue;
        this.tableData = [];
        if (this.visible) {
          if (this.type === "org") {
            this.text = "机构";
            await this.getTreeData();
          } else if (this.type === "corp") {
            this.text = "单位";
            await this.getCorpTreeData();
          } else if (this.type === "depart") {
            this.text = "部门";
            await this.getTreeData();
          }
          if (this.org && this.org.length) {
            await this.getOrgData();
          }
        }
      },
    },
    visible(newValue) {
      if (newValue === false) {
        this.$emit("update:show", newValue);
      }
    },
    filterText(val) {
      this.$refs.lsOrgSelectTree?.filter(val);
    },
  },
  methods: {
    /*获取已选机构列表*/
    async getOrgData() {
      try {
        // const { success, message, data } = await lsfetch.post("/api/base/org/list", {
        //   uniqueIds: props.org
        // });
        const { success, message, data } = await request({
          url: "/api/base/org/list",
          method: "post",
          data: {
            uniqueIds: this.org
          }
        });
        if (!success) {
          return this.$message.error("获取已选机构失败:" + message);
        }
        let temp = [];
        if (data && data.length) {
          temp = data;
        }
        this.tableData = temp;
        await this.$nextTick(() => {
          if (this.tableData && this.tableData.length) {
            for (let i = 0; i < this.tableData.length; i++) {
              (this.$refs.lsOrgSelectTree)?.setChecked(this.tableData[i][this.nodeKey], true);
            }
          }
        });
      } catch (e) {
        this.$message.error("获取已选机构失败:" + e.message || e);
      }
    },
    /*返回当前操作用户所在租户的机构树形数据*/
    async getTreeData() {
      try {
        // const { success, message, data } = await lsfetch.get(
        //   "/api-type/base/current/operate/org/tree/by-ten",
        //   {}
        // );
        const { success, message, data } = await request({
          url: "/api-type/base/current/operate/org/tree/by-ten",
          method: "get"
        });
        if (!success) {
          return this.$message.error("获取机构树失败:" + message);
        }
        await this.$nextTick(() => {
          let temp = [];
          if (data && data.length) {
            temp = data;
          }
          this.treeData = JSON.parse(JSON.stringify(temp));
          this.handleNodeState();
        });
      } catch (e) {
        this.$message.error("获取机构树失败:" + e.message || e);
      }
      // this.$nextTick(() => {
      //   this.treeData = JSON.parse(JSON.stringify(mockData));
      //   this.handleNodeState();
      // });
    },
    /*返回当前操作用户所在租户的单位树形数据*/
    async getCorpTreeData() {
      try {
        // const { success, message, data } = await lsfetch.get(
        //   "/api-type/base/current/operate/org/tree/by-ten/corp",
        //   {}
        // );
        const { success, message, data } = await request({
          url: "/api-type/base/current/operate/org/tree/by-ten/corp",
          method: "get"
        });
        if (!success) {
          return this.$message.error("获取机构树失败:" + message);
        }
        await this.$nextTick(() => {
          let temp = [];
          if (data && data.length) {
            temp = data;
          }
          this.treeData = JSON.parse(JSON.stringify(temp));
          this.handleNodeState();
        });
      } catch (e) {
        this.$message.error("获取机构树失败:" + e.message || e);
      }
      // this.$nextTick(() => {
      //   this.treeData = JSON.parse(JSON.stringify(mockData));
      //   this.handleNodeState();
      // });
    },
    /*控制树节点及checkbox显示隐藏(这里采用的是elementplus和elementui都兼容的写法，只考虑的elementplus的话，通过设置props里面的class更简单)*/
    handleNodeState() {
      this.$nextTick(() => {
        if (this.type === "depart") {
          const nodes = document.querySelectorAll(".ls-corp-node");
          for (let i = 0; i < nodes.length; i++) {
            nodes[i].parentNode.querySelector(".el-checkbox").style.display =
              "none";
          }
        }
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data[this.treeProps.label].indexOf(value) > -1;
    },
    /*单选时将表头的checkbox隐藏*/
    cellClass(row) {
      if (row.columnIndex === 0 && !this.multiple) {
        return "disabledCheck";
      }
    },
    /*点击checkbox(单选)*/
    handleNodeCheck(data, checked) {
      if (checked && !this.multiple) {
        this.$refs.lsOrgSelectTree?.setCheckedNodes([data]);
        this.$nextTick(() => {
          this.tableData = this.$refs.lsOrgSelectTree?.getCheckedNodes();
        });
      }
    },
    /*添加*/
    addOrg() {
      const nodes = this.$refs.lsOrgSelectTree?.getCheckedNodes();
      if (nodes.length === 0) {
        // return this.$message.error("请选择要添加的" + text);
      }
      if (this.multiple) {
        nodes.map((item) => {
          const data = this.tableData.find(
            (row) => row[this.nodeKey] === item[this.nodeKey]
          );
          if (!data) {
            this.tableData.push({
              ...item,
              children: null, //这里不置空的话，会影响到表格选择
            });
          }
        });
      } else {
        this.tableData = nodes;
      }
    },
    /*移除*/
    removeOrg() {
      const selections = this.$refs.checkedOrgTable.selection;
      if (selections.length === 0) {
        // return this.$message.error("请选择要移除的" + text);
      }
      for (let i = 0; i < selections.length; i++) {
        const index = this.tableData.findIndex(
          (row) => row[this.nodeKey] === selections[i][this.nodeKey]
        );
        if (index >= 0) {
          this.$refs.lsOrgSelectTree?.setChecked(
            selections[i][this.nodeKey],
            false
          );
          this.tableData.splice(index, 1);
          i--;
        }
      }
    },
    /*已选机构表格移除机构*/
    delOrg(row, index) {
      this.tableData.splice(index, 1);
      this.$refs.lsOrgSelectTree?.setChecked(row[this.nodeKey], false);
    },
    /*已选机构表格筛选*/
    setRowClass({ row }) {
      // const orgName = lstool.trim(search.orgName);
      const orgName = this.search.orgName;
      if (orgName) {
        if (row.name.indexOf(orgName) > -1) {
          return "row-show";
        } else {
          return "row-hide";
        }
      } else {
        return "row-show";
      }
    },
    /*设置树节点能否选择*/
    selectable(node) {
      return this.tableData.find(
        (item) => item[this.nodeKey] === node[this.nodeKey]
      );
    },
    /*关闭弹窗/取消*/
    close() {
      this.$emit("close");
      this.visible = false;
    },
    /*确定*/
    submit() {
      if (this.tableData.length) {
        this.$emit("submit", this.tableData);
        this.visible = false;
      } else {
        this.$message.error("请选择人员");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ls-select-org-dialog {
  display: flex;
  flex-direction: column;

  .ls-select-org-main {
    width: 100%;

    > .main {
      width: 100%;
      height: calc(100% - 50px);

      &:after {
        display: block;
        width: 0;
        height: 0;
        content: "";
        overflow: hidden;
        clear: both;
      }

      > .left,
      > .right {
        height: 100%;
        border-radius: 4px;
        border-top: 1px solid #ebeef5;
        border-bottom: 1px solid #ebeef5;

        > .header {
          display: flex;
          padding: 10px;
          align-items: center;
          background-color: #f5f7fa;

          > span {
            position: relative;
            top: -1px;
            margin-left: 5px;
          }
        }
      }

      > .left {
        float: left;
        width: calc((100% - 95px) * 0.5);
        box-sizing: border-box;
        border-left: 1px solid #ebeef5;
        border-right: 1px solid #ebeef5;

        &.long {
          width: 50%;
        }

        > .main {
          width: 100%;
          height: calc(100% - 40px);

          > .content-box {
            width: 100%;
            height: calc(100% - 62px);
          }
        }
      }

      > .right {
        width: calc((100% - 95px) * 0.5);
        border-bottom: none;
        box-sizing: border-box;
        float: right;

        > .ls-select-search-box {
          border-left: 1px solid #ebeef5;
          border-right: 1px solid #ebeef5;
        }

        > .table-box {
          width: 100%;
          height: calc(100% - 101px);

          .table-btn-delete {
            color: var(--szgc-element-danger-color);
            cursor: pointer;

            &:hover {
              color: var(--szgc-element-danger-color);
            }
          }

          .ls-table {
            ::v-deep(.disabledCheck) {
              .cell {
                .el-checkbox {
                  display: none;
                }
              }
            }
          }

          ::v-deep(.el-table) {
            .row-show {
              display: table-row;
            }

            .row-hide {
              display: none;
            }
          }
        }
      }

      > .middle {
        float: left;
        display: flex;
        height: 100%;
        width: 70px;
        padding: 0 12px;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        > .el-button {
          margin: 8px 0;
        }
      }
    }

    > .footer {
      padding-top: 16px;
      text-align: center;
    }
  }
}
</style>
